import React, { useCallback, useLayoutEffect, useState } from 'react';

import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { IconButton } from '@mui/material';

import Button from 'pages/UserInfo/components/Button';
import waitScriptReady from 'utils/wait-for-script-ready';

import useStyles from './styles';

interface Props {
    compact?: boolean;
    className?: string;
}

const SupportButton: React.FC<Props> = ({ compact, className }) => {
    const { classes, cx } = useStyles();
    const [isOpen, setIsOpen] = useState(false);

    useLayoutEffect(() => {
        waitScriptReady('ze-snippet').then(() => {
            window.zE?.('webWidget', 'hide');
            window.zE?.('webWidget', 'setLocale', 'en');
            window.zE?.('webWidget:on', 'close', () => {
                setIsOpen(false);
                window.zE?.('webWidget', 'hide');
            });
        });
    }, []);

    const handleOpen = useCallback(
        () =>
            waitScriptReady('ze-snippet').then(() => {
                setIsOpen(true);
                window.zE?.('webWidget', 'show');
                window.zE?.('webWidget', 'open');
            }),
        []
    );

    return compact ? (
        <IconButton
            className={cx(classes.common, classes.icon, className)}
            onClick={handleOpen}
            disabled={isOpen}
            disableRipple
            disableFocusRipple
        >
            <HelpOutlineIcon />
        </IconButton>
    ) : (
        <Button
            fullWidth
            disableElevation
            disableRipple
            disableFocusRipple
            variant="outlined"
            disabled={isOpen}
            onClick={handleOpen}
            className={cx(classes.common, classes.regular, className)}
        >
            {'Support'}
        </Button>
    );
};

export default SupportButton;
